import {
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';

// A chosen value as a settled row: the value, a line of detail under it, and the way to change it,
// either a Change action beside it or the whole row
@Component({
  selector   : 'wor-booking-diary-selected',
  template: require('./booking-diary.selected.component.html')
})
export class BookingDiarySelectedComponent {
  @Input() isChangeShown : boolean = true;

  @Output() changeRequested : EventEmitter<void> = new EventEmitter<void>();

  onRowClick ( event : Event ) : void {
    if ( this.startsChange(event) ) {
      this.changeRequested.emit();
    }
  }

  // a row acting as a button answers Space as well, without scrolling the modal
  onRowKeySpace ( event : Event ) : void {
    if ( this.startsChange(event) ) {
      event.preventDefault();

      this.changeRequested.emit();
    }
  }

  // a link inside the row keeps its own job, so only the rest of the row starts a change
  private startsChange ( event : Event ) : boolean {
    return !this.isChangeShown && !( event.target as HTMLElement ).closest('a, button');
  }
}
